module.exports = {
  g: {
    t: '{a}',
    u: 'CLP'
  },
  login: {
    startText: '¡Ahorra tiempo, ahorra dinero, <br/>salva tu cordura!',
    account: 'Ingrese su email',
    accountn: 'Ingrese su correo electrónico',
    password: 'Ingrese su contraseña',
    rePassword: 'Confirma tu contraseña',
    referrer: 'Código de invitación',
    noAccount: '¿No tienes una cuenta? <b>Regístrate</b>',
    hasAccount: '¿Ya tienes una cuenta? <b>Volver a iniciar sesión</b>',
    login: 'INICIAR SESIÓN',
    register: 'REGISTRARSE'
  },
  t: {
    CurrentBalance: 'Saldo Actual',
    Home: 'Inicio',
    Markets: 'Mercados',
    Trade: 'Comerciar',
    quote: 'Cotización',
    orderConfirm: 'Confirmación de pedido',
    scale: 'escala',
    TradingPair: 'Par de Comercio',
    direction: 'Dirección',
    HighestPrice: 'Precio Más Alto',
    TodayChange: 'Cambios de Hoy',
    TodayHigh: 'Máximo de Hoy',
    TodayLow: 'Mínimo de Hoy',
    Time: 'Hora',
    min: 'min',
    h: 'h',
    d: 'd',
    BuyMore: 'Comprar Más',
    BuyLess: 'Comprar Menos',
    CurrentPrice: 'Precio Actual',
    SelectExpirationTime: 'Seleccionar Tiempo de Expiración',
    Amount: 'Cantidad',
    Amountn: 'Cantidad de datos',
    ExpectedEarnings: 'Ganancias Esperadas',
    ComplaintOrSuggestion: 'Queja o Sugerencia',
    Balance: 'Saldo',
    Unlicensed: 'Sin Licencia',
    Win: 'Ganancia',
    Loss: 'Pérdida',
    Abnormal: 'Anormal',

    InvitationCode: 'Código de Invitación',
    CopyInvitationLink: 'Copiar Enlace de Invitación',
    MembersReferred: 'Miembros Referidos',
    TotalInvited: 'Total Invitados',

    RESET: 'RESTABLECER',
    Avatar: 'Avatar',
    Username: 'Correo Electrónico',
    MobileNumber: 'Número de Teléfono',
    LoginPassword: 'Contraseña de Inicio de Sesión',
    TransactionPassword: 'Contraseña de Transacción',
    OldPaymentPassword: 'Antigua Contraseña de Pago',
    NewPaymentPassword: 'Nueva Contraseña de Pago',
    ReNewPaymentPassword: 'Repetir Nueva Contraseña de Pago',
    Oldpassword: 'Contraseña Antigua',
    NEWpassword: 'Contraseña Nueva',
    ConfirmNewPassword: 'Repetir Nueva Contraseña',
    ChangeAvatar: 'Cambiar Avatar',

    MyProfile: 'Mi Perfil',
    BankInformation: 'Información Bancaria',
    records: 'Registros',
    ReferAFriend: 'Referir a un Amigo',
    Proposal: 'Propuesta',
    DownloadApp: 'Descargar Aplicación',
    HelpCenter: 'Centro de Ayuda',
    logOut: 'Cerrar Sesión',
    WriteSuggestions: 'Escribir Sugerencias',
    proposal: 'propuesta',
    submit: 'enviar',
    ResetLoginPassword: 'Restablecer Contraseña de Inicio de Sesión',
    ResetPaymentPassword: 'Restablecer Contraseña de Pago',
    ClearCache: 'Limpiar Caché',
    MyLinkedAccounts: 'Mis Cuentas Vinculadas',
    ADDBANKINFORMATION: 'AGREGAR INFORMACIÓN BANCARIA',
    ADDUSDTWALLET: 'AGREGAR BILLETERA USDT',
    BankIFSC: 'Código IFSC Bancario',
    PayName: 'Nombre',
    BankName: 'Banco',
    BankAccountNumber: 'Numero de cuenta',
    PayBank: 'Cuenta',
    payRut: 'RUT',
    payType: 'Tipo de cuenta',
    buttonLoading: 'Cargando',
    usdtwalletaddress: 'Dirección de Billetera USDT',
    Email: 'Correo Electrónico',

    Transactions: 'Actas',
    Recharge: 'Aplicar',
    Withdraw: 'Retirar',
    next: 'Enviar',
    Notice1: '1.¡Atención! No envíes la solicitud de datos varias veces.',
    Notice2: '2.Una vez que hayas enviado exitosamente la solicitud de datos, por favor contacta a tu recepcionista.',
    Notice3: '3.Si encuentras problemas durante el proceso de solicitud de datos, consulta a tu recepcionista.',
    rechargePlaceholder: 'Un poco más cada día',
    SelectChannel: 'Seleccione el método de pago',
    PaymentOptions: 'Opciones de pago',
    confirmRecharge: 'CONFIRMAR RECARGA',
    confirmWithdraw: 'ENVIAR RETIRO',
    WalletAddress: 'Dirección de la billetera',
    inputHash: 'hash de transacción',
    PaymentPassword: 'Contraseña de pago',
    HandlingFee: '{n}% Tarifa de manejo',
    PaymentPasswordPlaceholder: 'Por favor ingrese la contraseña de pago',
    creditScore: 'Crédito',
    tradeMore: 'Comprar Más',
    tradeLess: 'Comprar Menos',
    processing: 'Tratamiento',
    reviewing: 'Revisando',
    completed: 'Terminado',
    refused: 'Rechazado'
  },
  component: {
    noMore: 'No hay Más',
    loading: 'cargando...',
    pulling: 'estirando...',
    loosing: 'soltando...',
    confirm: 'CONFIRMAR',
    cancel: 'CANCELAR'
  },
  page: {
    Options: 'Opciones',
    avatar: 'AVATAR',
    start: 'inicio',
    login: 'Iniciar Sesión',
    cashin: 'Aplicar',
    cashinTitle: 'Solicitar datos',
    cashout: 'RETIRAR',
    forget: 'Olvidé',
    register: 'Regístrate',
    wallet: 'Billetera',
    home: 'Inicio',
    invest: 'Invertir',
    investDetail: 'Detalle de Inversión',
    investBid: 'Oferta de Inversión',
    transaction: 'Transacción',
    user: 'Miembro',
    mission: 'Misión',
    addBankCard: 'Agregar Tarjeta Bancaria',
    addUSDTWallet: 'Agregar Billetera USDT',
    MaxonVIPLevel: 'Nivel VIP',
    team: 'Equipo',
    invite: 'REFERIR A UN AMIGO',
    REWARDCENTER: 'CENTRO DE RECOMPENSAS',
    setting: 'Configuración',
    articleDetail: 'Detalle de Artículo',
    message: 'NOTIFICACIONES',
    messageDetail: 'Detalle de Mensaje',
    withdraw: 'Retirar',
    order: 'Orden',
    member: 'Miembro',
    proposal: 'PROPUESTA',
    MyProfile: 'Mi Perfil',
    nickName: 'Apodo',
    paysubmit: 'Enviar Pago',
    games: 'Juegos'
  },
  msg: {
    logOutSuccess: 'Cierre de Sesión Exitoso',
    optSendSuccess: 'Envío de opt Exitoso',
    passwordChangeSuccess: 'Cambio de Contraseña Exitoso',
    loginSuccess: 'Inicio de Sesión Exitoso',
    registerSuccess: '¡Registro Exitoso!',
    noTotalAmount: 'No has seleccionado ninguna apuesta',
    Success: 'Operación Exitosa',
    fail: 'Operación Fallida',
    copySuccess: 'Copia Exitosa',
    ConfirmAction: '¿Confirmar Acción?',
    networkError: 'Error de Red',
    notEq: 'Entrada diferente dos veces',
    NotNull: 'El contenido no puede estar vacío',
    noProgress: 'Tareas no asignadas',
    noAmount: 'Por favor, ingresa la cantidad',
    noReferrerAccount: 'Por favor, ingresa la cuenta de referencia',
    noInputAccount: 'Por favor, introduzca el correo electrónico',
    passwordNum6: 'La contraseña requiere al menos seis dígitos',
    emailFail: 'El formato de correo electrónico es incorrecto',
    mobileError: 'Número de dígitos incorrecto',
    lengh11: 'El número de teléfono debe tener 11 dígitos',
    minAmount: 'La cantidad mínima no puede ser menor que {a}',
    notTime: 'El tiempo de retiro es \n {t}',
    PreparingRefresh: 'Preparando para refrescar'
  }
}



// WEBPACK FOOTER //
// ./src/lang/Es.js